import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { useIsMounted } from "hooks/useIsMounted";
import checkValidURL from "helpers/checkValidURL";

import URLs from "setts/urls";

import PictureFall from "assets/img/products/bodycell-sm-eraser-cream.webp";
import styles from "./lazyImg.module.scss";

const Picture = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin:auto;background:%23fff;display:block;' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3E%3Cpath d='M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50' fill='%23e15b64' stroke='none'%3E%3CanimateTransform attributeName='transform' type='rotate' dur='1s' repeatCount='indefinite' keyTimes='0;1' values='0 50 51;360 50 51'%3E%3C/animateTransform%3E%3C/path%3E%3C/svg%3E`;

const LazyImg = ({ src, alt, className, fallback = PictureFall, ...props }) => {
  const url = checkValidURL(src);
  const _isMounted = useIsMounted();

  const isAbsolute =
    url || url.protocol === "http:" || url.protocol === "https:";

  const _src = isAbsolute ? src : URLs.baseURL + "/" + src;
  const [_source, setSource] = useState(Picture);
  const [_isLoad, setLoad] = useState(false);

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      if (!_isMounted) return;

      setLoad(true);
      setSource(_src);
    };

    img.onerror = () => {
      if (!_isMounted) return;

      setLoad(true);
      setSource(fallback);
    };

    if (src !== null) {
      img.src = _src;
    } else {
      setSource(fallback);
    }

    return () => {
      img.onload = null;
      img.onerror = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!_source) return null;

  return (
    <img
      key={_source}
      src={_source}
      alt={alt}
      className={classnames(styles.image, className, {
        [styles.spinner]: !_isLoad,
      })}
      {...props}
    />
  );
};

export default LazyImg;
